export default __webpack_public_path__ + "static/media/twitter (1).b7f58e65.svg";